import { useTable } from "react-table";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import {
  defaultDateDisplay,
  formatCurrency,
  truncateString,
  defaultDateOnlyDisplay,
  jounralStatusMap,
} from "../../../helpers";
import primaryComponents from "../../primaryComponents";
import { pathConstants } from "../../../routes/pathContants";
import { useNavigate } from "react-router-dom";

const useJournalEntriesTable = ({ journalEntries }) => {
  const navigate = useNavigate();

  const columns = useMemo(
    () => [
      {
        Header: "Reference",
        accessor: "reference",
        Cell: ({ cell: { value }, row }) => (
          <span>
            <Link
              className="purple--text"
              to={
                row?.original?.status === "DRAFT"
                  ? pathConstants.ACCOUNTING_EDIT_JOURNAL_ENTRY({
                      reference: row?.original["reference"],
                    })
                  : pathConstants.ACCOUNTING_JOURNAL_ENTRY_DETAILS({
                      reference: row?.original["reference"],
                    })
              }
              style={{
                fontSize: "12px",
                textDecoration: "underline",
              }}
            >
              {value}
            </Link>
            <span className="d-block">
              {defaultDateDisplay(row?.original?.created_at)}
            </span>
          </span>
        ),
      },
      {
        Header: "Narration",
        accessor: "description",
        Cell: ({ cell: { value }, row }) => (
          <Link
            className="purple--text"
            to={
              row?.original?.status === "DRAFT"
                ? pathConstants.ACCOUNTING_EDIT_JOURNAL_ENTRY({
                    reference: row?.original["reference"],
                  })
                : pathConstants.ACCOUNTING_JOURNAL_ENTRY_DETAILS({
                    reference: row?.original["reference"],
                  })
            }
            style={{
              fontSize: "12px",
            }}
          >
            {value}
          </Link>
        ),
      },
      {
        Header: "Credit Amount",
        accessor: "total_credit",
        Cell: ({ cell }) =>
          formatCurrency({
            value: cell.value,
            currencyCode: cell?.row?.original?.store?.currency_code,
          }),
      },
      {
        Header: "Debit Amount",
        accessor: "total_debit",
        Cell: ({ cell }) =>
          formatCurrency({
            value: cell.value,
            currencyCode: cell?.row?.original?.store?.currency_code,
          }),
      },
      {
        Header: "Initiated By",
        accessor: "initiated_by",
        Cell: ({ cell: { value } }) =>
          value ? truncateString(value?.first_name, 15) : "N/A",
      },
      {
        Header: "Entry Type",
        accessor: "entry_type",
        Cell: ({ cell: { value } }) => (
          <span>{value ? value.replace("_", " ") : "N/A"}</span>
        ),
      },
      {
        Header: "Journal Date",
        accessor: "entry_date",
        Cell: ({ cell: { value } }) => (
          <span>{defaultDateOnlyDisplay(value)}</span>
        ),
      },
      {
        Header: "Status",
        accessor: "status_label",
        Cell: ({ cell: { value }, row }) => (
          <span
            className={`${jounralStatusMap[row?.original?.status]} text-capitalize`}
          >
            {value}
          </span>
        ),
      },
      {
        Header: "Store",
        accessor: "store",
        Cell: ({ cell: { value } }) => value?.name || "N/A",
      },
      {
        Header: "Action",
        Cell: ({ row }) => (
          <>
            {row?.original?.status === "DRAFT" ? (
              <primaryComponents.Button
                onClick={() =>
                  navigate(
                    pathConstants.ACCOUNTING_EDIT_JOURNAL_ENTRY({
                      reference: row?.original["reference"],
                    }),
                  )
                }
                classNames={"btn btn--primary smallBtn"}
              >
                Edit
              </primaryComponents.Button>
            ) : (
              <primaryComponents.Button
                onClick={() =>
                  navigate(
                    pathConstants.ACCOUNTING_JOURNAL_ENTRY_DETAILS({
                      reference: row?.original["reference"],
                    }),
                  )
                }
                classNames={"btn btn--primary smallBtn"}
              >
                View
              </primaryComponents.Button>
            )}
          </>
        ),
      },
    ],
    [journalEntries],
  );

  const instance = useTable({ columns, data: journalEntries });
  return {
    instance,
  };
};

export default useJournalEntriesTable;
